import React, { useEffect, useState } from 'react';

import './scss/app-consult.scss';
import Color from '@/tool/color';
import { WeixinIcon, PhoneIcon3 } from '@styled/icon';
import Contact01 from '@static/contact/0014.png';
import Contact02 from '@static/contact/contact01.png';
import Contact03 from '@static/contact/wewe111.png';
import Contact05 from '@static/contact/0013.png';
import Contact06 from '@static/contact/contact-111.png';

interface IProps {}
interface IState {}

const AppRoot = (props: IProps, state: IState) => {
  const [isPhone, setPhone] = useState(false);
  const [isQrcode, setQrcode] = useState(false);

  useEffect(() => {
    return () => {};
  }, []);

  const onConsult = () => {
    const $btn = document.getElementById('nb_invite_ok');
    if ($btn) $btn.click();
  };

  return (
    <section id="consult" className="app-consult_555">
      <img src={Contact01} alt="" className="img-110 img-111"
        onMouseEnter={() => setPhone(true)}
        onMouseLeave={() => setPhone(false)} />
      <img src={Contact02} alt="" className="img-110 img-112"
        onClick={onConsult} />
      {/* <img src={Contact03} alt="" className="img-110 img-113"
        onMouseEnter={() => setQrcode(true)}
        onMouseLeave={() => setQrcode(false)} /> */}
      {/* <img src={Contact05} alt="" className="img-110 img-115" /> */}
      {isPhone ? (
        <section className="phone-50">
          <img src={Contact01} alt="" className="img-115" />
          <p>
            <span>400 - 101 - 9070</span>
            <i>7*24小时在线客服</i>
          </p>
        </section>
      ) : null}
      {isQrcode ? (<section className="qrcode-50">
        <span>微信联系薪酬专家</span>
        <img src="https://file.smartsalary.cn/web-img%402.0/home/contact-111.png" alt="" />
      </section>) : null}
    </section>
  );
};

export default AppRoot;
